<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="full-height core-container-content">
	<mat-tab-group
		class="core-flex-forwarding"
		animationDuration="0ms"
		(selectedTabChange)="onTabChange($event)"
	>
		<mat-tab>
			<mat-divider></mat-divider>
			<ng-template mat-tab-label>
				<!-- 
					matBadge="&#8288;" uses the Unicode 'Word Joiner' character (U+2060) 
					as a workaround to display an empty Material badge.
					Material badges typically require text or numbers, but this approach 
					allows us to visually indicate an error state with an empty badge 
					without showing any content.
				-->
				<mat-icon
					automationId="mobileInfoIcon"
					aria-hidden="false"
					matBadge="&#8288;"
					matBadgeSize="small"
					matBadgeColor="warn"
					[matBadgeHidden]="!ticketFormHasErrors || activeTab === 'details'"
				>
					calendar_clock
				</mat-icon>
			</ng-template>
			<div class="docked-ticket-view-layout">
				<ticket-edit-form
					[ticketForm]="ticketForm"
					[editTicket$]="ticket$"
					[roleList$]="roles$"
					[locationList$]="locations$"
					[projectMembers$]="projectMembers$"
					[priorityList$]="priorityList$"
					[isAdmin$]="planAccessCheck.isAdmin$"
					[calendarWorkdays]="calendarWorkdays"
					[activeLineDate$]="activeLineDate$"
				>
				</ticket-edit-form>
			</div>
		</mat-tab>
		<mat-tab>
			<mat-divider></mat-divider>
			<ng-template mat-tab-label>
				<mat-icon
					automationId="mobileCustomFieldsIcon"
					aria-hidden="false"
					matBadge="&#8288;"
					matBadgeSize="small"
					matBadgeColor="warn"
					[matBadgeHidden]="!ticketCustomFieldsFormHasErrors || activeTab === 'customFields'"
				>
					wysiwyg
				</mat-icon>
			</ng-template>
			<!-- Custom Fields -->
			<div class="custom-fields-layout">
				<p>{{ appStrings.CUSTOM_FIELD_PLURAL }}</p>
				<form #customFieldsForm [formGroup]="customFieldsListFormGroup">
					<custom-fields-list
						#customFields
						*ngIf="ticket$ | async as t"
						[editedTicketId]="ticketId"
						[combinedEdit$]="ticket$"
						[ticketEditCombinedData]="t"
						[customFieldsApi]="customFieldsApi"
						[isFloatingTickets]="false"
						[customFieldsListFormGroup]="customFieldsListFormGroup"
						[saveCustomFieldsRequested$]="saveCustomFieldsRequested$"
						[cancelCustomFieldsRequested$]="cancelCustomFieldsRequested$"
						[allowList$]="allowList$"
						[planId]="(plan$ | async)?.$id"
					>
					</custom-fields-list>
				</form>
			</div>
		</mat-tab>
		<mat-tab *ngIf="isFileAttachEnabled$ | async">
			<mat-divider></mat-divider>
			<ng-template mat-tab-label>
				<mat-icon automationId="mobileAttachFileIcon">attach_file</mat-icon>
			</ng-template>
			<attached-images [ticketContext]="ticketContext" [ticketId]="ticketId"></attached-images>
		</mat-tab>
	</mat-tab-group>
	<button-footer
		class="docked-ticket-button-footer"
		[saveOrCloseButtonText]="appStrings.SAVE"
		(buttonSaveOrClose)="saveOrClose()"
		[disabled]="buttonSaveDisabled"
		[formId]="'ticketEditForm'"
	>
		<div leftButton>
			<button
				mat-button
				color="primary"
				automationId="mobileUpdateStatus"
				*ngIf="(hasAccess$ | async) && !(ticket$ | async).view.isActualized"
				(click)="updateStatus()"
			>
				{{ getLeftButtonText((ticket$ | async).view.isActualized) | uppercase }}
			</button>
			<button
				mat-button
				color="primary"
				automationId="mobileStartWork"
				*ngIf="showStartWorkButton$ | async"
				(click)="onStartWork()"
			>
				{{ appStrings.START_WORK | uppercase }}
			</button>
		</div>
		<button
			middleButton
			mat-button
			color="primary"
			automationId="mobileCancelTicket"
			(click)="cancel($event)"
		>
			{{ appStrings.CANCEL | uppercase }}
		</button>
	</button-footer>
</div>

<!-- Loading state -->
<ng-template [loadingBlocker]="isCloseInProgress$ | async"></ng-template>
